import type { Command } from "../types.ts";

export const social: Command = {
  name: "social",
  aliases: ["contact", "links"],
  description: "Where to find me.",
  run(ctx) {
    const socials = ctx.term.profile.socials;
    const w = Math.max(...socials.map((s) => s.label.length));
    for (const s of socials) {
      const label = e(s.label).padEnd(w, " ").replace(/ /g, "&nbsp;");
      const val = s.url
        ? `<a class="link" href="${e(s.url)}" target="_blank" rel="noopener noreferrer">${e(s.value)}</a>`
        : `<span class="c-text">${e(s.value)}</span>`;
      ctx.printHTML(`  <span class="c-accent">${label}</span>  ${val}`);
    }
  },
};

function e(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
